import * as React from "react";
import { useProductData } from "@grandvisionhq/fun-products";
import { GraphCrossSellProducts } from "@grandvisionhq/search";
import { a as getAlgoliaCrossSellConfig } from "./algolia.js";
import "next/router";
import "@grandvisionhq/bloomreach";
import "@grandvisionhq/utils";
const CrossSellProductsGraphContainer = () => {
  const { activeVariant, product } = useProductData();
  const algoliaConfig = getAlgoliaCrossSellConfig(product.productType);
  return /* @__PURE__ */ React.createElement(
    GraphCrossSellProducts,
    {
      activeVariant,
      product,
      algoliaConfig
    }
  );
};
export {
  CrossSellProductsGraphContainer as C
};
//# sourceMappingURL=CrossSellProductsGraphContainer.js.map
